window.handleLogEvent = (fromRails) => {
  if (fromRails) {
    var eventData = fromRails;
    var eventName = fromRails.event_name;
    delete eventData.event_name;
    document.addEventListener('turbo:load', function (event) {
      if(typeof(gtag) === 'function'){
        gtag('event', eventName, eventData);
      }
    });
  }
};

if (window.__logEvent) {
  window.handleLogEvent(window.__logEvent);
  window.__logEvent = null;
}
